export const Header = () => (
  <header className="bg-black/80 backdrop-blur-xl border-b border-white/10">
    <div className="container mx-auto px-6 py-4 h-12">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="bg-red-600 rounded-bl-lg rounded-br-lg flex items-center justify-center py-1 px-2">
            <i className="fab fa-git-alt text-white text-sm"></i>
            <h1 className="text-xl font-bold text-white ml-2">Hub</h1>
          </div>
        </div>
        <nav className="flex items-center space-x-6">
          <a href="/" className="text-zinc-400 hover:text-white">Browse</a>
          <a href="/explore" className="text-zinc-400 hover:text-white">Explore</a>
        </nav>
      </div>
    </div>
  </header>
)
